import { useEffect, useState } from "react";
import MainMenu from "./MainMenu";
import ArabicFontSettings from "./ArabicFontSettings";
import EnglishFontSettings from "./EnglishFontSettings";
import BookmarksSection from "./BookmarksSection";
import TranslationSettings from "./TranslationSettings";
import RecitationSettings from "./RecitationSettings";
import ReciterMenu from "./ReciterMenu";

const SidebarContainer=({translationMenu,reciterMenu,recitationMenu})=>{
    const [currentSection,setCurrentSection]=useState(0);

    useEffect(()=>{},[currentSection]);

    return(
        <>
            {
                currentSection!==0?
                    <div className="flex items-center p-2 text-gray-900 transition duration-75 rounded-lg text-white cursor-pointer my-5 hover:bg-dark_blue" onClick={()=>{
                        setCurrentSection(0);
                    }}>
                        <img src="/images/right-arrow-search.svg" width="24" height="24" alt="Back arrow" className="rotate-180"/>
                        <span className="ml-3">Back</span>
                    </div>
                :
                    null
            }

            {
                currentSection===0?
                    <MainMenu translationMenu={translationMenu} reciterMenu={reciterMenu} recitationMenu={recitationMenu} sectionSwitchFunc={setCurrentSection}/>
                :
                    null
            }

            {
                currentSection===1?
                    <BookmarksSection/>
                :
                    null
            }

            {
                currentSection===2?
                    <TranslationSettings/>
                : 
                    null
            }

            {
                currentSection===3?
                    <RecitationSettings/>
                : 
                    null
            }

            {
                currentSection===4?
                    <ReciterMenu/>
                : 
                    null
            }

            {
                currentSection===5?
                    <ArabicFontSettings/>
                :
                    null
            }

            {
                currentSection===6?
                    <EnglishFontSettings/>
                :
                    null
            }
        </>
    )
}

export default SidebarContainer;